var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_470_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8403 28.0001C19.2425 27.7716 18.9683 27.3373 18.9633 26.6811C18.9332 22.8277 16.1003 19.467 12.3567 18.8283C8.42983 18.1582 4.66906 20.4568 3.42335 24.2934C3.17493 25.0584 3.03102 25.846 3.03317 26.6519C3.03532 27.3147 2.76971 27.768 2.15545 27.9994H1.51254C0.921188 27.7351 0.659875 27.2862 0.686364 26.6176C0.82955 22.9912 2.36378 20.1437 5.28619 18.0881C6.81828 17.0107 8.5365 16.4574 10.3972 16.337C15.4237 16.0129 20.0858 19.5429 21.1218 24.8029C21.2356 25.3825 21.2836 25.9701 21.3129 26.5628C21.3473 27.2482 21.101 27.7249 20.4832 27.9986H19.8403V28.0001Z",
    fill: "#222E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11992 7.02055C4.11635 3.13723 7.1712 0.0269347 10.9678 -7.33456e-05C14.7665 -0.0270813 17.8951 3.15256 17.8793 7.01398C17.8636 10.9009 14.823 14.0083 11.0286 14.0368C7.25425 14.0653 4.0827 10.8849 4.11921 7.02055H4.11992ZM10.9849 2.38904C8.49997 2.38758 6.45957 4.46063 6.45743 6.9877C6.45528 9.56222 8.4792 11.6462 10.9821 11.6469C13.5029 11.6477 15.5361 9.58266 15.5375 7.01909C15.539 4.45698 13.5072 2.3905 10.9849 2.38904Z",
    fill: "#222E50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_470_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6316,
    height: 28,
    fill: "white",
    transform: "translate(0.684204)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.1f7cf67d7a3c20999dee9f76ac36f3a9.svg";
export { ForwardRef as ReactComponent };